<template>
  <div class="home-container">
    <div class="home-content">  
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="审核状态" prop="status" style="width: 80%">
                <el-select clearable filterable v-model="searchForm.status" placeholder="请选择状态">
                    <el-option label="待审核" value="1"></el-option>
                    <el-option label="审核通过" value="2"></el-option>
                    <el-option label="已拒绝" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>        
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          @click="back"
          style="width: 90px"
          >返回</el-button
        >
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="name" label="场地名称" align="center">
        </el-table-column>
        <el-table-column prop="userName" label="用户信息" align="center">
        </el-table-column>   
        <el-table-column prop="phone" label="联系电话" align="center">
        </el-table-column>  
        <el-table-column prop="startTime" label="预约开始时间" align="center">
        </el-table-column>   
        <el-table-column prop="endTime" label="预约结束时间" align="center">
        </el-table-column>                
        <el-table-column prop="illustrate" label="预约描述" align="center" show-overflow-tooltip>
        </el-table-column>  
        <el-table-column prop="status" label="审核状态" align="center" :formatter="statusList">
        </el-table-column>    
        <el-table-column prop="createTime" label="提交时间" align="center">
        </el-table-column>      
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="see(scope.row)"
              >查看</el-button
            >
            <el-button
               v-if="scope.row.status == 1"
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>                          
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog title="审核" :visible.sync="isAddModal" width="50%" @close="close">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >  
           <el-row>
            <el-col :span="24">
              <el-form-item label="选择审核结果" prop="status">
                <el-select clearable filterable v-model="addData.status" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>    
            <el-col :span="24">
              <el-form-item label="描述" :prop="addData.status == 3 ?'des':''">
                <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入描述"
                v-model="addData.des">
                </el-input>
              </el-form-item>
            </el-col>                   
          </el-row>         
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" 
            >确 定</el-button
          >
        </span>
      </el-dialog>    
      <!-- 查看 -->
      <el-dialog title="查看" :visible.sync="isAddModals" width="50%">
        <el-form
          ref="forms"
          :model="fromData"
          label-width="90px"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片" prop="img">
                <!-- <multigraph
                  :url.sync="fromData.img"
                  :src="fromData.img"
                  :many="1"
                ></multigraph> -->
                <el-image style="width: 150px;height: 150px;margin: 0 10px 10px 0;" fit="cover" :src="item" v-for="(item,i) in fromData.img" :preview-src-list="fromData.img"></el-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="用户名称" >
                {{ fromData.userName }}
              </el-form-item>
            </el-col>           
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="审核描述" >
                {{ fromData.des == "0"?'':fromData.des }}
              </el-form-item>
            </el-col>         
          </el-row>  
          <el-row>
            <el-col :span="24">
              <el-form-item label="预约描述" >
                {{ fromData.illustrate }}
              </el-form-item>
            </el-col>         
          </el-row>                   
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isAddModals = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>        
    </div>
  </div>
</template>

<script>
import ueditor from "../../../components/ueditor";
import multigraph from "../../../components/multigraph";
export default {
  components:{
    ueditor,
    multigraph
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isAddModal:false,
      isShowloading:false,
      isAddModals:false,
      options:[{
        label:'通过',
        value:2
      },{
        label:'拒绝',
        value:3
      }],
      fromData:{},
      addData: {
        status: "",
        des:''
      },
      addDataRules: {
        status: [{ required: true, message: "请选择审核结果", trigger: "blur" }],
        des: [{ required: true, message: "请输入审核描述", trigger: "blur" }]
      },      
      searchForm: {
        status:''
      },
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    back(){
        this.$emit('timeBack',true)
    },
    see(row){
      this.fromData = JSON.parse(JSON.stringify(row))
      this.fromData.img = this.fromData.img.split(',')
      this.isAddModals = true
    },
        // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    }, 
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var data = {
            id: this.addData.id || "",
            des: this.addData.des,
            status: this.addData.status,
          };
          this.$Apis.venueBookingRecordVerify(data).then((res) => {
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    statusList(row){
      if(row.status == 1){
        return "待审核"
      }else if(row.status == 2){
        return "已通过"
      }else if(row.status == 3){
        return "已拒绝"
      }
    },    
    // 审核
    updataCharacter(row){
        this.addData.id = row.id;
        this.isAddModal = true
    },
    onLoad() {
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        status:this.searchForm.status || '1,2,3'
      }
      this.$Apis.venueBookingRecordList(data).then(res=>{
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>